import type { DashboardWidgetConfiguration } from './widget-definition';
import { period } from './query-period';

export const salesPerformanceReportWidget: DashboardWidgetConfiguration = {
  widgetId: "sales.performance-report",
  name: "Sales performance report",
  description: "Sales performance report using the reusable report-widget visualization.",
  apps: [
    "home",
    "sales",
    "crm",
    "finance",
    "invoicing",
    "point-of-sale",
    "subscriptions",
  ],
  template: "report",
  query: {
    kind: "single",
    query: {
      version: 1,
      source: "sales.analysis",
      ...period(30),
      select: [
        {
          type: "field",
          field: "status",
          as: "status",
        },
        {
          type: "aggregate",
          function: "sum",
          field: "revenue",
          as: "revenue",
        },
      ],
      group_by: [
        {
          field: "status",
        },
      ],
      order_by: [
        {
          ref: "revenue",
          direction: "desc",
        },
      ],
      limit: 8,
    },
  },
  inputs: {
    title: "Sales performance report",
    subtitle: "Live RQL report",
    output: "category_series",
    visualization: "bar",
    icon: "average",
    showTimeControls: true,
  },
  dummyData: {
    value: "$84,250",
    series: [
      18,
      30,
      24,
      42,
      35,
    ],
  },
  limits: {
    minWidth: 6,
    maxWidth: 12,
    minHeight: 3,
    maxHeight: 8,
    defaultWidth: 6,
    defaultHeight: 4,
  },
};
